import { useTranslation } from "react-i18next";
import type { MenuGroup as MenuGroupType } from "../../../utils/menu";
import { MenuIcon } from "../icons";

interface MenuGroupProps {
  group: MenuGroupType;
}

/**
 * One menu group (course): an icon marker on the connecting line, the group
 * name with an optional time eyebrow, and the list of items below — each with
 * an optional description and dietary badges.
 */
export const MenuGroup = ({ group }: MenuGroupProps) => {
  const { t } = useTranslation();

  return (
    <li className="menu-group">
      <div className="menu-marker">
        <span className="menu-icon">
          <MenuIcon iconKey={group.icon} />
        </span>
      </div>
      <div className="menu-content">
        {group.time?.trim() && (
          <span className="menu-time">{group.time.trim()}</span>
        )}
        <h2 className="menu-group-name">{group.name}</h2>
        <ul className="menu-items">
          {group.items.map((item) => (
            <li key={item.id} className="menu-item">
              <p className="menu-item-name">{item.name}</p>
              {item.description && (
                <p className="menu-item-description">{item.description}</p>
              )}
              {item.dietary && item.dietary.length > 0 && (
                <ul className="menu-dietary">
                  {item.dietary.map((tag) => (
                    <li key={tag} className="menu-tag">
                      {t(`dietary.${tag}`)}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
};
